import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
    selector: 'tt-product-data-harvest',
    templateUrl: './product-data-harvest.component.html',
    styleUrls: ['./product-data-harvest.component.css'],
    standalone: false
})
export class ProductDataHarvestComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public gridPo?: GridOptions;

    public gridPoWorkSum?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2590, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private loadGridPo() {
        if (!this.gridPo) {
            this.gridPo = new Grid()
                .setRememberId('w_productdataharvest_po_grid')
                .setLoadDataFunction({
                    method: 2591,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: null })
                .setToolbar({ wrapping: true });
        } else {
            this.gridPo?.gridfunc?.read();
        }
    }

    private loadGridPoWorkSum() {
        if (!this.gridPoWorkSum) {
            this.gridPoWorkSum = new Grid()
                .setRememberId('w_productdataharvest_powork_sum_grid')
                .setLoadDataFunction({
                    method: 2592,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: null })
                .setToolbar({ wrapping: true });
        } else {
            this.gridPoWorkSum?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGridPo();
        this.loadGridPoWorkSum();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prod_id: string;
    prod_name: string;
    prod_id_and_name: string;
    argtype: string;
    argvalue: string;
}
